"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOriginDefinition = void 0;
function getOriginDefinition(resolved) {
    for (const r of resolved) {
        const { symbol } = r;
        if (symbol._kind === 'class' || symbol._kind === 'element') {
            if (symbol.alias && !symbol[`-st-extends`]) {
                continue;
            }
            else {
                return r;
            }
        }
    }
    return resolved[0];
}
exports.getOriginDefinition = getOriginDefinition;
//# sourceMappingURL=resolve.js.map